<h2>Granska och godkänn</h2>
<p>Nu återstår bara att granska dina uppgifter och godkänna dem genom att
  signera med BankID.
</p>
@if (!this.data()) {
  <spb-please-wait/>
}